import { useState, useEffect } from 'react';

/**
 * Custom hook to debounce any fast-changing value
 * @param {any} value - The value to be debounced (e.g. search string)
 * @param {number} delay - Time in milliseconds to wait before updating
 * @returns {any} - The debounced value
 */
export const useDebounce = (value, delay = 500) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        // Set a timer to update the debounced value after the delay
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        // Cleanup: Clear the timer if the value changes before the delay is over
        // This is what prevents the update on every keystroke
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};
